module.exports = __webpack_public_path__ + "img/chess-pawn.583a4314.svg";